import React from "react"
import Layout from "../components/layout"
import LP from "../components/landingPage/landingPage"

export default function Home() {
  return (
    <div style={{ color: `teal` }}>
      <Layout>
      <LP />
      </Layout>
      
    </div>
  )
}